import { HttpErrorResponse, HttpInterceptorFn, HttpStatusCode } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, EMPTY, throwError } from 'rxjs';
import { AuthService } from 'src/app/core/auth/services/auth.service';
import { CustomErrorHandler } from 'src/app/core/services/custom-error-handler.service';

import { SKIP_ACCESS_REDIRECT } from './skip-access-redirect.token';
import { SKIP_AUTH_REDIRECT } from './skip-auth-redirect.token';
import { SKIP_ERROR_HANDLER } from './skip-error-handler.token';

export const ErrorInterceptor: HttpInterceptorFn = (request, next) => {
	const errorHandler = inject(CustomErrorHandler);
	const authService = inject(AuthService);
	const router = inject(Router);

	return next(request).pipe(
		catchError((error: HttpErrorResponse) => {
			switch (error.status) {
				case HttpStatusCode.Unauthorized: {
					if (request.context.get(SKIP_AUTH_REDIRECT)) {
						return throwError(() => error);
					}
					authService.onSessionExpired();
					return EMPTY;
				}
				case HttpStatusCode.Forbidden: {
					if (request.context.get(SKIP_ACCESS_REDIRECT)) {
						return throwError(() => error);
					}
					router.navigate(['/access-denied']);
					return EMPTY;
				}
				default: {
					if (!request.context.get(SKIP_ERROR_HANDLER)) {
						errorHandler.handleBackendError(error);
					}
					return throwError(() => error);
				}
			}
		})
	);
};
